/* eslint-disable max-len */
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import {
    hooks as commonHooks,
    types as commonTypes,
    utils as commonUtils,
} from '@sitebuilder/common';
import {
    getTextSchemaProperties,
    getStyleSchemaProperties,
    getLayoutSchemaProperties,
} from '../utils';
import { themeStyles, defaultStyles } from './DownloadCSV.styles';

export interface WidgetProperties extends commonTypes.WidgetPropertiesBase {
    downloadbuttonHtml: string;
    typographyClass?: string;
    downloadFileName?: string;
    downloadCsvData?: string;
    isTransformData?: boolean;
    functionToTransform?: string;
}

const DownloadCSV = (props: commonTypes.WidgetInstanceProps) => {
    const widgetProperties = commonHooks.useWidgetProperties<WidgetProperties>(
        props.widgetInstanceId
    );
    const {
        styles,
        downloadbuttonHtml,
        downloadFileName,
        downloadCsvData,
        isTransformData,
        functionToTransform,
    } = widgetProperties || props;
    const { data } = props;

    let isRender = {
        renderSection: true,
        downloadCsvData: downloadCsvData,
        downloadFileName: downloadFileName,
        downloadbuttonHtml: downloadbuttonHtml,
    };

    const transformFunctionName = `${props.widgetInstanceId}-transform`;

    try {
        // eslint-disable-next-line no-new-func
        const transformedData =
            isTransformData &&
            commonUtils.transformDataWithGlobals(transformFunctionName, functionToTransform, data);

        if (transformedData) {
            isRender = { ...isRender, ...transformedData };
        }
    } catch (e) {
        console.log(e);
    }

    const i18n = commonHooks.useLocalization();

    const theme = data?.themeSelected;

    const onDownloadClick = () => {
        const csvContent =
            'data:text/csv;charset=utf-8,' + encodeURIComponent(isRender.downloadCsvData as any);
        const link = document.createElement('a');
        link.setAttribute('href', csvContent);
        link.setAttribute('download', i18n.format(isRender.downloadFileName, data));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return isRender.renderSection ? (
        <button
            css={css`
                ${!theme ? defaultStyles : themeStyles}${getTextSchemaProperties(
                    widgetProperties,
                    data?.colorSpace
                )}${getStyleSchemaProperties(widgetProperties)}${getLayoutSchemaProperties(
                    widgetProperties
                )}${styles || ''}
            `}
            className={`${
                widgetProperties?.typographyClass ? widgetProperties.typographyClass : ''
            }`}
            onClick={() => onDownloadClick()}
            aria-label={i18n.format(isRender.downloadbuttonHtml, data)}
            dangerouslySetInnerHTML={{ __html: i18n.format(isRender.downloadbuttonHtml, data) }}
        />
    ) : (
        <></>
    );
};

export default DownloadCSV;
